module.exports = __webpack_public_path__ + "static/media/recipe.9149090d.png";